import { create } from 'zustand';
import type { DayNote } from '@daynote/shared-types';
import { getDataSource } from '../data';

interface CalendarState {
  currentMonth: string; // YYYY-MM
  dayNotesByDate: Record<string, DayNote>;
  loading: boolean;
  locked: boolean; // 免费用户访问超过 90 天前的数据时

  setMonth: (month: string) => void;
  loadMonth: (month: string) => Promise<void>;
  upsertDayNote: (dayNote: DayNote) => void;
}

const formatMonth = (d = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;

export const useCalendarStore = create<CalendarState>((set, get) => ({
  currentMonth: formatMonth(),
  dayNotesByDate: {},
  loading: false,
  locked: false,

  setMonth: (month) => set({ currentMonth: month }),

  loadMonth: async (month) => {
    set({ loading: true });
    try {
      const { dayNotes, locked } = await getDataSource().getMonth(month);
      const map: Record<string, DayNote> = { ...get().dayNotesByDate };
      for (const dn of dayNotes) {
        map[dn.date] = dn;
      }
      set({ dayNotesByDate: map, locked: !!locked });
    } finally {
      set({ loading: false });
    }
  },

  upsertDayNote: (dn) =>
    set((s) => ({ dayNotesByDate: { ...s.dayNotesByDate, [dn.date]: dn } })),
}));
